import { useMutation } from '@tanstack/react-query';
import { API } from '~/shared/API/api';

export const useCreateRentSession = (onCreateSuccess: () => void) => {
  const mutation = useMutation({
    mutationFn: (data: SessionStartData) => {
      return API.createSession(data.id, data.auto_id);
    },
    onSuccess: onCreateSuccess,
  });
  return {
    create: mutation.mutate,
    data: mutation.data,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    isLoading: mutation.isPending,
  };
};

export interface SessionStartData {
  id: string | number;
  auto_id: number;
  //card_id: number;
}
